module.exports = {
  siteUrl: 'https://johnmantas.com',

  siteLang: 'en-us',
  siteName: 'John Mantas - Web Developer',
  siteShortName: 'John Mantas',
  siteDescription: 'Personal portfolio and home of John Mantas projects for websites, web apps and games.',

  siteBackgroundColor: '#f7f0eb',
  siteThemeColor: '#a2466c',
  siteIcon: require.resolve('../images/favicon.png'),

  defaultImage: 'https://johnmantas.com/images/jm-logo-black-bg-512.png',
  defaultImageWidth: '512',
  defaultImageHeight: '512'
}